module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-1-large-8ef4effe4a631396a19eaabb6ed9ca85.jpg";